<template>
  <v-layout
    justify-end
    align-center
  >
    <span class="caption grey--text text--lighten-1 label-author">{{
      label.author | shortName
    }}</span>
    <v-menu
      ref="label-menu"
      menu-props="offsetY"
      :close-on-content-click="false"
      :disabled="disabled"
    >
      <v-chip
        slot="activator"
        text-color="white"
        label
        small
        :color="getColorForGroup(label.value[1], label.name)"
      >
        {{ getVariantTitleForGroup(label.value[0], label.name) }}
      </v-chip>

      <v-list>
        <v-list-tile
          v-for="(variant, index) in getAvailableVariantsForGroup(
            label.value[0],
            label.name
          )"
          :key="index"
          @click="changeLabel(variant.id, label.value[0], label.name, true)"
        >
          <v-list-tile-title>
            {{
              variant.description || variant.title
            }}
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-switch
            v-model="controlValue"
            hide-details
            :disabled="label.value[1].disabled"
            :label="`${getControlValueLabel(label.value[1], label.name)}`"
            @change="
              changeLabel(controlValue ? 1 : 0, label.value[1], label.name)
            "
          />
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-layout>
</template>

<script>
import lables from "./lables.js";

export default {
  props: ["item", "index", "disabled"],
  data() {
    return {
      labels: lables,
      controlValue: null,
      label: null,
    };
  },
  computed: {
    items() {
      return this.$store.getters["oldVersionWarehouseDetails/items"];
    },
    selectedRow() {
      return this.$store.getters["oldVersionWarehouseDetails/selectedRow"];
    },
  },
  watch: {
    label: {
      handler() {
        this.controlValue = this.label.value[1].value === 1;
      },
      deep: true,
    },
    item: {
      handler() {
        this.getExLabel(this.item.shippingEx);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.$watch(
      () => {
        return this.$refs["label-menu"].isActive;
      },
      (newVal) => {
        if (newVal) {
          this.$store.commit(
            "oldVersionWarehouseDetails/setSelectedRow",
            this.index,
          );
        }
        if (!newVal) {
          this.selectedRow === this.index
            ? this.$store.commit(
              "oldVersionWarehouseDetails/setSelectedRow",
              null,
            )
            : this.selectedRow;
        }
      },
    );
  },
  methods: {
    getVariantTitleForGroup(label, groupName) {
      const group = this.labels[groupName];
      return group.value[label.name].variants.find((v) => v.id === label.value)
        .title;
    },
    getColorForGroup(label, groupName) {
      const group = this.labels[groupName];
      return group.value[label.name].variants.find((v) => v.id === label.value)
        .color
        ? group.value[label.name].variants.find((v) => v.id === label.value)
          .color
        : "grey";
    },
    getAvailableVariantsForGroup(label, groupName) {
      const group = this.labels[groupName];
      return group.value[label.name].variants.filter(
        (v) => v.id !== label.value,
      );
    },
    getControlValueLabel(label, groupName) {
      const controlValue = this.controlValue ? 1 : 0;
      const group = this.labels[groupName];
      const variant = group.value[label.name].variants.find(
        (v) => v.id === controlValue,
      );
      return variant ? variant.title : "";
    },
    async changeLabel(newValue, label, groupName, close) {
      if (close && this.$refs["label-menu"]) {
        this.$refs["label-menu"].isActive = false;
      }

      await this.$store.dispatch(
        "oldVersionWarehouseDetails/saveShippingLabel",
        {
          shippingId: this.item.shippingId,
          label: {
            name: label.name,
            value: newValue,
          },
        },
      );

      const item = this.items.find((item) => {
        return item.shippingId === this.item.shippingId;
      });

      function capitalizeFirstLetter(src) {
        return src.charAt(0).toUpperCase() + src.slice(1);
      }

      item.shippingEx[capitalizeFirstLetter(label.name)] = newValue;

      if (label.name === "exWhoDoing" && (newValue === 5 || newValue === 6)) {
        item.shippingEx.ExDocumentInSystem = 0;
      }
    },
    getExLabel(item) {
      return (this.label = {
        name: "ex",
        group: true,
        value: [
          { name: "exWhoDoing", value: item.ExWhoDoing },
          {
            name: "exDocumentInSystem",
            value: item.ExDocumentInSystem,
            disabled: item.ExWhoDoing === 5 || item.ExWhoDoing === 6,
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.v-menu__content {
  background-color: white;
  height: 160px;
  width: 160px;
}
</style>
